// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Br9Z","requiredAsterisk":"Info_requiredAsterisk__3G0zz"};